/*
 * Module for the Member Statement Process job criteria page
 */
rs.module("content/jobs/criteria/memberstatementprocess",

    ["common/select-helper", "common/visibility"],

    function (selectHelper, visibility) {

        // Initialize the page
        function initialize(jsSelectors, batchTypes, constants, searchControl, backendUrl, printers, preferredPrinter) {
            var criteria = $.js(jsSelectors.criteria);

            var batchTypeRadioContainer = criteria.js(jsSelectors.batchTypeRadioContainer);
            var searchContainer = criteria.js(jsSelectors.searchContainer);
            var groupContainer = criteria.js(jsSelectors.groupContainer);
            var messageSelectContainer = criteria.js(jsSelectors.messageSelectContainer);
            var messageSelect = criteria.js(jsSelectors.messageSelect);
            var messageSelectText = criteria.js(jsSelectors.messageSelectText);
            var isCreatingNewMessage = criteria.js(jsSelectors.isCreatingNewMessage);
            var messageCreateContainer = criteria.js(jsSelectors.messageCreateContainer);
            var messageCreateLink = criteria.js(jsSelectors.messageCreateLink);
            var messageCreateCancelLink = criteria.js(jsSelectors.messageCreateCancelLink);
            var messageCreateName = criteria.js(jsSelectors.messageCreateName);
            var messageCreateText = criteria.js(jsSelectors.messageCreateText);
            var distributionContainer = criteria.js(jsSelectors.distributionContainer);
            var distributionMethodSelect = criteria.js(jsSelectors.distributionMethodSelect);
            var printerSelect = criteria.js(jsSelectors.printerSelect);

            // Get Select Helpers for selects where we're updating options and properties
            var messageSelectHelper = selectHelper.getHelper(messageSelect);
            var printerSelectHelper = selectHelper.getHelper(printerSelect);

            // Register click event for batch type radio buttons 
            batchTypeRadioContainer.find("input").click(onBatchTypeChanged);

            // Message select change handler
            messageSelect.change(updateMessageText);

            // Message create link click handler
            messageCreateLink.click(onMessageCreateLinkClicked);

            // Message create link click handler
            messageCreateCancelLink.click(onMessageCreateCancelLinkClicked);

            // Distribution method change handler
            distributionMethodSelect.change(onDistributionMethodChanged);

            // Batch Type has changed
            function onBatchTypeChanged() {

                // get selected batch type
                var selectedBatchType = batchTypeRadioContainer.find("input:checked").val();

                // clear the search control, which will also repopulate plans (since we're handling onSelectionCleared above)
                searchControl.clear();

                // set visibility of controls based on selected batch type
                visibility.setVisible(searchContainer, selectedBatchType == batchTypes.individual);
                visibility.setVisible(groupContainer, selectedBatchType == batchTypes.group);
                visibility.setVisible(distributionContainer, selectedBatchType == batchTypes.individual);
            }

            // set the message text field for the currently selected message
            function updateMessageText() {

                if (messageSelect.val()) {
                    $.getJSON(backendUrl, { statementMessageKey: messageSelect.val() }).done(function (data) {
                        messageSelectText.val(data.messageText);
                    });
                }
                else {
                    messageSelectText.val("");
                }
            }

            // Message create link click handler
            function onMessageCreateLinkClicked() {
                visibility.setVisible(messageSelectContainer, false);
                visibility.setVisible(messageCreateContainer, true);

                // reset statement message key to null
                messageSelectHelper.setValue(null);

                // set creating new message flag used for validation
                isCreatingNewMessage.val(true);
            }

            // Message create cancel link click handler
            function onMessageCreateCancelLinkClicked() {
                visibility.setVisible(messageSelectContainer, true);
                visibility.setVisible(messageCreateContainer, false);

                // set creating new message flag used for validation
                isCreatingNewMessage.val(false);

                // clear out message create fields and reset message select text
                messageCreateName.val("");
                messageCreateText.val("");
                updateMessageText();
            }

            // Enable or disable Printer fields based on distributionMethodSelect
            function onDistributionMethodChanged() {

                if (distributionMethodSelect.val() == constants.distribute) {

                    printerSelectHelper.setDisabled(false);
                    printerSelectHelper.replaceOptions(printers);

                    // Since we have reloaded printers, we should again default to the user's preferred Printer
                    if (preferredPrinter != '') {
                        printerSelectHelper.setValue(preferredPrinter);
                    }
                }
                else {
                    printerSelectHelper.clearOptions();
                    printerSelectHelper.setDisabled(true);
                }
            }
        }

        var exports = {
            initialize: initialize,
        };

        return exports;
    }
);